<template>
  <div>
    <div
      class="loading-screen"
      v-if="!isWhiteLabel"
      :class="{'dark': $store.state.isDarkTheme && !forceLightMode}"
    >
      <aha-logo-loader :display-text="false" />
    </div>
    <div class="spinner" v-else>
      <div class="bounce1" />
      <div class="bounce2" />
      <div class="bounce3" />
    </div>
  </div>
</template>

<script>
import Util from '@/util'

export default {
  name: 'LoadingScreen',
  props: {
    forceLightMode: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isWhiteLabel() {
      return Util.checkWhiteLabelDomain()
    },
  },
}
</script>

<style lang="scss" scoped>
.loading-screen {
  background-color: #fff;
  max-height: -webkit-fill-available; // fix height in ios safari (with address bar)
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 50;
  display: flex;
  align-content: center;
  flex-direction: column;
  justify-content: center;
  align-items: center;

}
.dark {
    background : black;
    color : white;
  }
@import "@/assets/scss/variables.scss";

.spinner {
  width: 70px;
  text-align: center;
}

.spinner > div {
  width: 10px;
  height: 10px;
  background-color: $primary-color;

  border-radius: 100%;
  display: inline-block;
  -webkit-animation: sk-bouncedelay 1.4s infinite ease-in-out both;
  animation: sk-bouncedelay 1.4s infinite ease-in-out both;
}

.spinner .bounce1 {
  -webkit-animation-delay: -0.32s;
  animation-delay: -0.32s;
}

.spinner .bounce2 {
  -webkit-animation-delay: -0.16s;
  animation-delay: -0.16s;
}

@-webkit-keyframes sk-bouncedelay {
  0%,
  80%,
  100% {
    -webkit-transform: scale(0);
  }
  40% {
    -webkit-transform: scale(1);
  }
}

@keyframes sk-bouncedelay {
  0%,
  80%,
  100% {
    -webkit-transform: scale(0);
    transform: scale(0);
  }
  40% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
}
@media only screen and (max-width: 1200px) {
  .header-nav-right-container {
    width: 680px;
  }
}
</style>
